module.exports = "### Where did React come from?\n\n- Recognize this symbol\n\n- Logo for a small startup in Menlo Park, CA\n\n======> \n- 2004, Mark Zuckerberg building Facebook in PHP\n\n======>\n - string concatenation\n\n  - good, easy to do\n\n- Big vulnerability\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_2.md
// module id = 1483
// module chunks = 0